import { render, staticRenderFns } from "./BankInfo.vue?vue&type=template&id=14935573&scoped=true"
import script from "./BankInfo.vue?vue&type=script&lang=ts"
export * from "./BankInfo.vue?vue&type=script&lang=ts"
import style0 from "./BankInfo.vue?vue&type=style&index=0&id=14935573&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14935573",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14935573')) {
      api.createRecord('14935573', component.options)
    } else {
      api.reload('14935573', component.options)
    }
    module.hot.accept("./BankInfo.vue?vue&type=template&id=14935573&scoped=true", function () {
      api.rerender('14935573', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bank/BankInfo.vue"
export default component.exports